module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Black.e67237b42566c16b14f39b59cb568b53.woff";